
import React, { useEffect, useState } from 'react';
import { FaMapMarker } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { urlWebsite } from '../../../../config';
import { useConfiguration } from '../../../../hooks/Configuration';
import { useLanguage } from '../../../../hooks/Language';
import { ApoioImg } from '../../../../pages/SponsorsPage/styles';
import {

    Capa, Container,



} from './styles';

const HomeApplicationLandingHorizontal = () => {
    const { configuration, projectHash } = useConfiguration();
    const { translate } = useLanguage();
    const event = configuration?.current_event_id_response;
    const dates = event?.date_text ? event?.date_text?.split('|') : [];

    const [theme, setTheme] = useState({
        titleColor: configuration?.current_event_id_response?.theme?.title_color || '#fff',
        textColor: configuration?.current_event_id_response?.theme?.text_color || '#fff',
        buttonColor: configuration?.current_event_id_response?.theme?.button_color || '#fff',
        buttonBackground: configuration?.current_event_id_response?.theme?.button_background || 'rgb(73, 177, 97)',
    })


    useEffect(() => {
        setTheme({
            titleColor: configuration?.current_event_id_response?.theme?.title_color || '#fff',
            textColor: configuration?.current_event_id_response?.theme?.text_color || '#fff',
            buttonColor: configuration?.current_event_id_response?.theme?.button_color || '#fff',
            buttonBackground: configuration?.current_event_id_response?.theme?.button_background || 'rgb(73, 177, 97)',
        })
    }, [configuration])


    return <Container>
        <Capa>
            <div className='header'>


                {configuration?.current_event_id_response?.image ? <img style={{ maxWidth: '950px', width: '100%' }} src={configuration?.current_event_id_response?.image ? `${urlWebsite}/${configuration?.current_event_id_response?.image}` : '/assets/logo.png'} /> : <></>}

                <div style={{ margin: '25px 0px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                    {event?.images && event?.images?.length > 0 && event?.images?.map(image => {

                        return <ApoioImg key={image?.url} src={`${urlWebsite}/${image?.url}`} computer={image?.computer} mobile={image?.mobile} />

                    })}
                </div>

                <div className="headerButtons">{configuration?.active_pages && configuration?.active_pages?.map(button => {
                    return button?.button !== 'yes' ? <></> : button?.type === 'external' ? <a href={button.url} target="_BLANK" style={{ width: "100%", maxWidth: "388px", }} ><button className='buttonBigGreen shadow' style={{ background: theme?.buttonBackground, color: theme?.buttonColor, margin: '0px' }}>{button?.title}</button></a> : <Link style={{ width: "100%", maxWidth: "388px", }} to={`/app/${projectHash}/${button.url}`} ><button className='buttonBigGreen shadow' style={{ background: theme?.buttonBackground, color: theme?.buttonColor, margin: '0px' }}>{button?.title}</button></Link>
                })}
                </div>
            </div>
        </Capa>
        {configuration?.current_event_id_response?.local ? <div className='localDiv'>
            <FaMapMarker size={30} color={"#fff"} />
            <div>
                <p className='mapiconP'> {translate(configuration?.current_event_id_response?.local)} {configuration?.current_event_id_response?.local_description ? <> <br />
                    {translate(configuration?.current_event_id_response?.local_description)}</> : <></>}  </p>


            </div>

        </div> : <></>}

    </Container>

}

export default HomeApplicationLandingHorizontal;